import { ScheduleWithSettings } from '../types/interfaces';

export const ScheduleTemplate: ScheduleWithSettings = {
  id: 0,
  name: '',
  description: '',
  periodType: 0,
  periodValue: 0,
  scheduleSettings: []
};
